// Публичный реестр копирайта Луни. Единственный источник текстов интерфейса (CLAUDE.md
// правило 16) — ключи ровно как в spec/08_copy.md: `onb.a1.title` → `copy.onb.a1.title`.
import { bowl, paywall } from './bowl'
import { compat } from './compat'
import { gate } from './gate'
import { limits } from './limits'
import { invite, onb } from './onboarding'
import { breakCopy, inbox, link, links, node, person, ray } from './links'
import { main } from './main'
import { natal } from './natal'
import { compliment, moodReply, verdict } from './pools'
import { legal } from './legal'
import { privacy } from './privacy'
import { profile } from './profile'
import { share } from './share'
import { push } from './push'
import { stats } from './stats'
import { webStub } from './web'
import type { Copy } from './types'

export const copy: Copy = {
  onb,
  invite,
  main,
  moodReply,
  links,
  node,
  person,
  ray,
  compliment,
  link,
  break: breakCopy,
  inbox,
  push,
  compat,
  verdict,
  natal,
  stats,
  profile,
  privacy,
  legal,
  bowl,
  limits,
  paywall,
  gate,
  share,
  webStub,
}

export { pickRotating, pickRotatingStable } from './pickRotating'
export type * from './types'
